import { cn } from '@streetferret/utils';

export interface SkeletonProps {
  className?: string;
  circle?: boolean;
}
export function Skeleton({ className, circle }: SkeletonProps) {
  return (
    <div
      className={cn(
        'animate-pulse bg-gray-3 dark:bg-dark-7',
        {
          'rounded-md': !circle,
          'rounded-full': circle,
        },
        className,
      )}
    />
  );
}
